/**
 * @generated SignedSource<<678c6e002d4433adee9dd82d934343ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ConferenceProviderOptions = "GOOGLE" | "NONE" | "TEAMS" | "ZOOM";
export type UserSettingsMutationInput = {
  adminDigestEnabled?: boolean | null;
  automaticallyWatchNotestreams?: boolean | null;
  department?: string | null;
  digest1on1sEnabled?: boolean | null;
  digestEmailFrequency?: string | null;
  digestMeetingsEnabled?: boolean | null;
  digestObjectivesEnabled?: boolean | null;
  digestSlackFrequency?: string | null;
  digestTeamsFrequency?: string | null;
  disableExternalUserCalendarLinks?: boolean | null;
  emailCommentsNotifyReplyResolve?: boolean | null;
  emailCommentsNotifyWatchedStreams?: boolean | null;
  emailMeetingBriefsNotifyReady?: boolean | null;
  emailNotificationsEnabled?: boolean | null;
  emailNotifyAboutAssignment?: boolean | null;
  emailNotifyAboutChannelsIJoined?: boolean | null;
  emailNotifyAboutDueDateChange?: boolean | null;
  emailNotifyAboutMention?: boolean | null;
  emailNotifyAboutNoteEdited?: boolean | null;
  emailNotifyAboutPostsInChannelsIWatch?: boolean | null;
  emailNotifyAboutRecordingsFirstViewed?: boolean | null;
  emailNotifyAboutTalkingPoint?: boolean | null;
  enableBrowserExtensionDots?: boolean | null;
  enableCalendarDescriptionLinks?: boolean | null;
  enableLiveReactions?: boolean | null;
  feedbackGivenToMeEmailEnabled?: boolean | null;
  feedbackGivenToMeSlackEnabled?: boolean | null;
  feedbackGivenToMeTeamsEnabled?: boolean | null;
  feedbackNeedsActionEmailEnabled?: boolean | null;
  feedbackNeedsActionSlackEnabled?: boolean | null;
  feedbackNeedsActionTeamsEnabled?: boolean | null;
  feedbackRequestIHaveSentEmailEnabled?: boolean | null;
  feedbackRequestIHaveSentSlackEnabled?: boolean | null;
  feedbackRequestIHaveSentTeamsEnabled?: boolean | null;
  feedbackSharedWithMeEmailEnabled?: boolean | null;
  feedbackSharedWithMeSlackEnabled?: boolean | null;
  feedbackSharedWithMeTeamsEnabled?: boolean | null;
  feedbackSummaryForMeetingsIHostEmailEnabled?: boolean | null;
  feedbackSummaryForMeetingsIHostSlackEnabled?: boolean | null;
  feedbackSummaryForMeetingsIHostTeamsEnabled?: boolean | null;
  firstWeekDay?: string | null;
  fullName?: string | null;
  googleMeetExtensionRecordingButtonEnabled?: boolean | null;
  image?: string | null;
  impending1on1EnableNotification?: boolean | null;
  impending1on1NotificationDeliveryPathways?: ReadonlyArray<string | null> | null;
  impending1on1NotificationDeliveryTimeUnit?: string | null;
  impending1on1NotificationDeliveryTimeValue?: number | null;
  impending1on1NotificationMeetingsWhitelist?: ReadonlyArray<string> | null;
  impendingOkrDueDateNotificationDeliveryTimeUnit?: string | null;
  impendingOkrDueDateNotificationDeliveryTimeValue?: number | null;
  impendingOkrDueDateNotificationEnabled?: boolean | null;
  manager?: string | null;
  managerDisabled?: boolean | null;
  meetingRecordingAvailableNotificationEnabled?: boolean | null;
  objectivesNotifyAssigned?: boolean | null;
  objectivesNotifyEndOfCycleReminder?: boolean | null;
  objectivesNotifyUpdated?: boolean | null;
  ongoingMeetingEnableNotification?: boolean | null;
  organization?: string | null;
  preferredConferenceProvider?: ConferenceProviderOptions | null;
  promptNotificationsSendViaEmail?: boolean | null;
  promptNotificationsSendViaSlack?: boolean | null;
  promptNotificationsSendViaTeams?: boolean | null;
  pushCommentsNotifyReplyResolve?: boolean | null;
  pushCommentsNotifyWatchedStreams?: boolean | null;
  pushMeetingBriefsNotifyReady?: boolean | null;
  pushNotificationsEnabled?: boolean | null;
  pushNotifyAboutAssignment?: boolean | null;
  pushNotifyAboutChannelsIJoined?: boolean | null;
  pushNotifyAboutDueDateChange?: boolean | null;
  pushNotifyAboutMention?: boolean | null;
  pushNotifyAboutNoteEdited?: boolean | null;
  pushNotifyAboutPostsInChannelsIWatch?: boolean | null;
  pushNotifyAboutRecordingsFirstViewed?: boolean | null;
  pushNotifyAboutTalkingPoint?: boolean | null;
  slackNotificationsEnabled?: boolean | null;
  teamsNotificationsEnabled?: boolean | null;
  theme?: string | null;
  timezonePreferences?: TimezonesInput | null;
  title?: string | null;
  voicePrintsEnabled?: boolean | null;
};
export type TimezonesInput = {
  extraTimezones?: ReadonlyArray<TimezoneInput | null> | null;
  preferredTimezone?: TimezoneInput | null;
};
export type TimezoneInput = {
  timezoneName: string;
  userLabel: string;
};
export type ProfileSetImageMutation$variables = {
  input: UserSettingsMutationInput;
};
export type ProfileSetImageMutation$data = {
  readonly updateSettings: {
    readonly viewer: {
      readonly settings: {
        readonly image: string | null;
      };
      readonly user: {
        readonly image: string;
      };
    } | null;
  } | null;
};
export type ProfileSetImageMutation = {
  response: ProfileSetImageMutation$data;
  variables: ProfileSetImageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "UserSettings",
  "kind": "LinkedField",
  "name": "settings",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileSetImageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserSettingsMutation",
        "kind": "LinkedField",
        "name": "updateSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": (v3/*: any*/),
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProfileSetImageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserSettingsMutation",
        "kind": "LinkedField",
        "name": "updateSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "deca9db3688116eb85ba432cd814ca21",
    "id": null,
    "metadata": {},
    "name": "ProfileSetImageMutation",
    "operationKind": "mutation",
    "text": "mutation ProfileSetImageMutation(\n  $input: UserSettingsMutationInput!\n) {\n  updateSettings(input: $input) {\n    viewer {\n      user {\n        image\n        id\n      }\n      settings {\n        image\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ce69220720864626edbf44a6238ac9c2";

export default node;
